import { BurgerMenuIcon } from '@libs/ui/ds/assets/icons'
import { IconWrap } from '@libs/ui/ds/lib/components/dataDisplay/IconWrap/base/IconWrap'
import { DropdownMenu } from '@libs/ui/ds/lib/components/overlays/DropdownMenu/base/DropdownMenu'
import { Tooltip } from '@libs/ui/ds/lib/components/overlays/Tooltip/base/Tooltip'
import { useDSTranslation } from '@libs/ui/ds/lib/internals'
import type { Screen } from '@libs/ui/ds/lib/theme'
import { useScreensMediaQuery } from '@libs/ui/ds/lib/theme/screens/useScreensMediaQuery/useScreensMediaQuery'
import type { FC, HTMLAttributes } from 'react'

import { useTopNavbarContext } from '../../TopNavbar.context'
import { TopNavbarItem } from '../TopNavbarItem/TopNavbarItem'

type Props = HTMLAttributes<HTMLButtonElement> & {
  className?: string

  options?: {
    label: string
    active?: boolean
    onClick?: () => void
  }[]
}

export const TopNavbarDropdownItem: FC<Props> = ({
  className,
  onClick,
  options,
  ...other
}) => {
  const { t } = useDSTranslation()
  const ctx = useTopNavbarContext()
  const match = useScreensMediaQuery({
    thresholdType: 'min',
    screenList: [ctx?.showDropdownBelowBreakpoint as Screen]
  })

  if (match) {
    return null
  }
  return (
    <DropdownMenu dropdownPosition='bottom-start' dropdownWidth='s'>
      <DropdownMenu.Target>
        <Tooltip label={t('ds.components.topNavbar.dropdownNav.tooltip')}>
          <TopNavbarItem
            className={className}
            onClick={onClick as () => void}
            role='button'
            tabIndex={0}
            {...other}
          >
            <IconWrap size='s' icon={<BurgerMenuIcon />} />
          </TopNavbarItem>
        </Tooltip>
      </DropdownMenu.Target>
      <DropdownMenu.Dropdown>
        {options?.map((option, idx) => (
          <DropdownMenu.Option
            key={idx}
            onClick={option.onClick}
            active={option.active}
          >
            {option.label}
          </DropdownMenu.Option>
        ))}
      </DropdownMenu.Dropdown>
    </DropdownMenu>
  )
}
